import { HTTP } from './httpClient'

export const MIN_PASSWORD_LENGTH = 12;

export const EXTERNAL_USER_REALM = {
  DEFAULT: 1 << 0,
  GOETEL_INTERNAL: 1 << 1,
  GU_USER: 1 << 2
}

export const PASSWORD_RULES = [
  (v) => !!v || 'Password ist ein Pflichtfeld',
  (v) =>
    v.length >= MIN_PASSWORD_LENGTH || `Das Password muss mindestens ${MIN_PASSWORD_LENGTH} Zeichen lang sein`,
  (v) =>
    /[a-z]/.test(v) ||
    'Das Password muss mindestens ein Kleinbuchstabe enthalten',
  (v) =>
    /[A-Z]/.test(v) ||
    'Das Password muss mindestens ein Großbuchstabe enthalten',
  (v) =>
    /[0-9]/.test(v) ||
    'Das Password muss mindestens eine Zahl und ein Sonderzeichen enthalten',
  (v) =>
    /(?=.*\W)/.test(v) ||
    'Das Password muss mindestens eine Zahl und ein Sonderzeichen enthalten'
];

export const get = (realm = null) => {
  const query = realm !== null ? `?realm=${realm}` : '';

  return HTTP.get('/external-users' + query);
}

export const register = (createUserDto, realm = EXTERNAL_USER_REALM.DEFAULT) => {
  return new Promise((resolve, reject) => {
    if (realm === undefined || realm === null) {
      realm = EXTERNAL_USER_REALM.DEFAULT;
    }

    const r = Object.entries(EXTERNAL_USER_REALM).filter(([_, r]) => r === realm);
    if (r.length !== 1) {
      return reject(new Error(`${realm} is not a valid realm`));
    }

    createUserDto.realm = realm;

    return resolve(HTTP.post('/authentication/external-register', createUserDto));
  })
}

export const toggleUserBlock = (user) => {
  if (user.disabledAt === null) {
    return blockUser(user.id);
  }

  return unblockUser(user.id);
}

export const blockUser = (userId) => {
  return HTTP.patch(`external-users/${userId}/lock`);
}

export const unblockUser = (userId) => {
  return HTTP.patch(`external-users/${userId}/release`);
}

export const changePassword = (newPassword) => {
  return HTTP.patch('authentication/external-users/password', newPassword);
}

export const setNewPassword = (userId, newPassword) => {
  return HTTP.patch(`external-users/${userId}/password`, {
    newPassword
  });
}

export default {
  MIN_PASSWORD_LENGTH,
  PASSWORD_RULES,
  EXTERNAL_USER_REALM,
  get,
  register,
  toggleUserBlock,
  blockUser,
  unblockUser,
  changePassword,
  setNewPassword
}
